
import './QrCodePet.css'
import horzintalLine from '../Images/horzintalLine.png'
import config from "../config.json";
import profileEdit from '../Images/contact.jpg'
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import { toast } from "react-toastify";
import phone from '../Images/phone2.png'
import instagram from '../Images/instagram2.png'
import telegram from '../Images/telegram2.png'
import sms from '../Images/sms2.png'



import whatsapp from '../Images/whatsapp.png'
import eita from '../Images/Eitaa.png'
import baleh from '../Images/bale.png'

export default function QrCodePet() {

    useEffect(() => {

    }, []);


    return (
        <>



            <div className="header">

                {/*<div className="inner-header flex">                                                        </div>*/}

            </div>
            <div id="waves">
                <svg
                    className="waves"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 24 150 28"
                    preserveAspectRatio="none"
                    shapeRendering="auto"
                >
                    <defs>
                        <path
                            id="gentle-wave"
                            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                        />
                    </defs>
                    <g className="parallax">
                        <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7)" />
                        <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                        <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                        <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff" />
                    </g>
                </svg>
            </div>


        </>

    );

}
